import * as actions from "@/AppRedux/actions/admin/rateDetailConfig/rateDetailConfigType"
import { RateData, RateDetailsListResponse } from "@/AppRedux/actions/admin/rateDetailConfig/rateDetailConfigType"

export type ProcessTypes = {
  status: boolean
  action: "RATE_DETAILS_LIST_REQUEST" | "RATE_DETAILS_GET_REQUEST" | "RATE_DETAILS_UPDATE_REQUEST" | "RATE_DETAILS_UPDATE_SORT_ORDER_REQUEST" | null
  message?: string | null
}

export type RateDetailsConfigState = {
  process: ProcessTypes
  dataSource: RateDetailsListResponse | null
  rateData: RateData | null
  loading: boolean
}

const initialState: RateDetailsConfigState = {
  process: {
    status: false,
    action: null,
    message: null,
  },
  loading: false,
  dataSource: null,
  rateData: null,
}

const rateDetailConfigReducer = (
  state: RateDetailsConfigState = initialState,
  action: actions.RateDetailsConfigAction,
): RateDetailsConfigState => {
  switch (action.type) {
    case actions.RATE_DETAILS_LIST_REQUEST:
      return {
        ...state,
        loading: true,
        process: initialState.process,
      }
    case actions.RATE_DETAILS_GET_REQUEST:
        return {
          ...state,
          loading: true,
          process: initialState.process,
          rateData: null,
        }
    case actions.RATE_DETAILS_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        process: {
          status: true,
          action: "RATE_DETAILS_LIST_REQUEST",
          message: "Content loaded successfully",
        },
        dataSource: action.payload,
      }
    case actions.RATE_DETAILS_GET_SUCCESS:
        return {
            ...state,
            loading: false,
            process: {
                status: true,
                action: "RATE_DETAILS_GET_REQUEST",
                message: "Rate data loaded successfully",
            },
            rateData: action.payload,
        }
    case actions.RATE_DETAILS_LIST_FAILED:
      return {
        ...state,
        loading: false,
        process: {
          status: false,
          action: "RATE_DETAILS_LIST_REQUEST",
          message: action.payload,
        },
        dataSource: null,
      }
    case actions.RATE_DETAILS_GET_FAILED:
        return {
            ...state,
            loading: false,
            process: {
                status: false,
                action: "RATE_DETAILS_GET_REQUEST",
                message: action.payload,
            },
            rateData: null,
        }
    case actions.RATE_DETAILS_UPDATE_REQUEST:
        return {
            ...state,
            loading: true,
            process: initialState.process,
        }
    case actions.RATE_DETAILS_UPDATE_SUCCESS:
        return {
            ...state,
            loading: false,
            process: {
                status: true,
                action: "RATE_DETAILS_UPDATE_REQUEST",
                message: "Rate data updated successfully",
            },
        }
    case actions.RATE_DETAILS_UPDATE_FAILED:
        return {
            ...state,
            loading: false,
            process: {
                status: false,
                action: "RATE_DETAILS_UPDATE_REQUEST",
                message: action.payload,
            },
        }
    case actions.RATE_DETAILS_UPDATE_SORT_ORDER_REQUEST:
        return {
            ...state,
            loading: true,
            process: initialState.process,
        }
    case actions.RATE_DETAILS_UPDATE_SORT_ORDER_SUCCESS:
        return {
            ...state,
            loading: false,
            process: {
                status: true,
                action: "RATE_DETAILS_UPDATE_SORT_ORDER_REQUEST",
                message: "Sort order updated successfully",
            },
        }
    case actions.RATE_DETAILS_UPDATE_SORT_ORDER_FAILED:
        return {
            ...state,
            loading: false,
            process: {
                status: false,
                action: "RATE_DETAILS_UPDATE_SORT_ORDER_REQUEST",
                message: action.payload,
            },
        }
    case actions.RATE_DETAILS_PROCESS_CLEAR:
        return {
            ...state,
            loading: false,
            process: initialState.process,
        }
    default:
      return state
  }
}

export default rateDetailConfigReducer
